import React from "react";
import { pillars } from "../data/content";

function About() {
  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div className="row g-5 align-items-start">
          <div className="col-lg-5" data-reveal>
            <p className="eyebrow">The company</p>
            <h2 className="section-title">Technology partner for data-driven organizations</h2>
            <p className="body-lg">
              <strong>MN2GROW</strong> is a Thailand-based data and software company. We combine data
              engineering, analytics and AI with full-stack web and application development — giving our
              clients a single, accountable team for the systems their business depends on.
            </p>
            <p className="body-muted">
              From product-data pipelines for e-commerce to ERP, CRM and cloud platforms, we focus on
              solutions that are secure, maintainable and measurable.
            </p>
            <a href="#contact" className="btn-corp btn-corp-dark mt-3">
              Talk to our team <i className="fa-solid fa-arrow-right" aria-hidden="true" />
            </a>
          </div>
          <div className="col-lg-7">
            <div className="pillars" data-reveal>
              {pillars.map((p) => (
                <div className="pillar" key={p.title}>
                  <i className={`fa-solid ${p.icon}`} aria-hidden="true" />
                  <h3>{p.title}</h3>
                  <p>{p.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
